import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';

import { getFormValues } from 'redux-form';

import Layout from 'components/common/Layout';
import Progress from 'components/common/Progress';
import Filter from 'components/common/Filter';
import TabNavigation from 'components/common/TabNavigation';
import ClaimStatusesTable from 'components/settings/ClaimStatusesTable';

import {
  fetchClaimStatuses,
  clearClaimStatuses,
} from 'redux/modules/claimStatuses';
import { addRouterParamsPageSettings } from 'redux/modules/routerParams';

import { getFilterChangeTypes } from 'utils/filterChangeTypes';
import objectDiff from 'utils/objectDiff';
import throttle from 'utils/throttle';

import { appTitle, titleSeparator } from 'config/helmetSettings';

class WorkspaceClaimStatuses extends Component {
  constructor(props) {
    super(props);

    this.state = {
      createDialogOpen: false,
    };

    this.onRequest = this.onRequest.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this);

    this.onThrottledRequest = throttle(this.onRequest, 2000, false, true);
  }

  componentWillMount() {
    this.props.actions.clearClaimStatuses();
  }

  componentDidMount() {
    this.onRequest();
  }

  componentWillReceiveProps(nextProps) {
    const { actions, filters, limit, offset, location } = this.props;
    const filtersChanged = nextProps.filters.Status !== filters.Status;
    let newOffset = offset;
    if (filtersChanged) {
      newOffset = 0;
    }
    if (nextProps.count > 0 && nextProps.count <= offset) {
      newOffset = offset - limit;
    }

    if (newOffset !== offset) {
      actions.addRouterParamsPageSettings({
        [location.pathname]: {
          offset: newOffset,
        },
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return ((Object.keys(objectDiff(this.props, nextProps)).length +
      Object.keys(objectDiff(this.state, nextState)).length) > 0);
  }

  componentDidUpdate(prevProps) {
    const { filters, limit, offset } = this.props;
    const limitChanged = prevProps.limit !== limit;
    const offsetChanged = prevProps.offset !== offset;
    const { throttledFiltersChanged, filtersChanged } = getFilterChangeTypes(
      prevProps.filters,
      filters,
      {
        textFilterKeys: ['Status'],
      },
    );

    if (throttledFiltersChanged) {
      this.onThrottledRequest();
    } else if (limitChanged || offsetChanged || filtersChanged) {
      this.onRequest();
    }
  }

  onRequest() {
    const { actions, filters, limit, offset } = this.props;
    const requestFilters = filters && Object.keys(filters).length > 0
      ? Object.keys(filters).map(key => ({
        name: key,
        operation: 'contains',
        val: filters[key],
        case_sensitivity: false,
      }))
      : null;
    actions.fetchClaimStatuses({
      limit,
      offset,
      filters: requestFilters,
      triggerLoading: true,
    });
  }

  onChangePage(event, page) {
    const { actions, location } = this.props;
    actions.addRouterParamsPageSettings({
      [location.pathname]: {
        offset: page * this.props.limit,
      },
    });
  }

  onChangeRowsPerPage(event) {
    const { actions, location } = this.props;
    window.scrollTo(0, 0);
    actions.addRouterParamsPageSettings({
      [location.pathname]: {
        limit: event.target.value,
        offset: 0,
      },
    });
  }

  render() {
    const { claimStatuses, count, loading, limit, offset } = this.props;
    const { createDialogOpen } = this.state;
    return (
      <Layout variant="settings">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Claim Statuses
          </title>
        </Helmet>
        <TabNavigation
          items={[
            {
              text: 'Note Categories',
              href: '/settings/workspace/note-categories',
            },
            {
              text: 'Document Categories',
              href: '/settings/workspace/document-categories',
            },
            {
              text: 'Workflow Statuses',
              href: '/settings/workspace/workflow-statuses',
            },
            {
              text: 'Claim Statuses',
              href: '/settings/workspace/claim-statuses',
            },
            {
              text: 'Claim Codes',
              href: '/settings/workspace/claim-adjustment-codes',
            },
          ]}
        />
        {/*<Filter
          form="claimStatusesFilter"
          placeholder="Search Claim Status"
        />*/}
        {loading > 0 &&
          <Progress fixed />
        }
        <ClaimStatusesTable
          items={claimStatuses}
          page={offset / limit}
          rowsPerPage={limit}
          count={count}
          onChangePage={this.onChangePage}
          onChangeRowsPerPage={this.onChangeRowsPerPage}
          loading={loading}
        />
      </Layout>
    );
  }
}

WorkspaceClaimStatuses.propTypes = {
  claimStatuses: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  count: PropTypes.number.isRequired,
  loading: PropTypes.number.isRequired,
  filters: PropTypes.shape({
    Status: PropTypes.string,
  }).isRequired,
  actions: PropTypes.shape({
    fetchClaimStatuses: PropTypes.func.isRequired,
    clearClaimStatuses: PropTypes.func.isRequired,
    addRouterParamsPageSettings: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  limit: PropTypes.number,
  offset: PropTypes.number,
};

WorkspaceClaimStatuses.defaultProps = {
  limit: 10,
  offset: 0,
};

const mapStateToProps = (store, ownProps) => {
  const claimStatusesFilterValues = getFormValues('claimStatusesFilter')(store);
  return {
    claimStatuses: store.claimStatuses.data,
    count: store.claimStatuses.count,
    filters: {
      ...claimStatusesFilterValues
        && claimStatusesFilterValues.Filter
        ? { Status: claimStatusesFilterValues.Filter }
        : {},
    },
    loading: store.claimStatuses.loading,
    ...store.routerParams.pageSettings[ownProps.location.pathname],
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchClaimStatuses,
    clearClaimStatuses,
    addRouterParamsPageSettings,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  WorkspaceClaimStatuses,
);



// WEBPACK FOOTER //
// ./src/pages/settings/WorkspaceClaimStatuses.js